import { render, staticRenderFns } from "./CustomerDetails.vue?vue&type=template&id=08a12e1e"
import script from "./CustomerDetails.vue?vue&type=script&lang=ts"
export * from "./CustomerDetails.vue?vue&type=script&lang=ts"
import style0 from "./CustomerDetails.vue?vue&type=style&index=0&id=08a12e1e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports